function formatPhoneNumber(number) {
    const cleaned = `${number}`.replace(/\D/g, '');               // Replace non numeric characters with ''.
    let phoneNumber;

    if (cleaned.length === 7) {
        let match = cleaned.match(/^(\d{3})(\d{4})$/);          // Creates groupings of 3, 3, & 4.
        phoneNumber = `${match[2]}-${match[3]}`;
    } else if (cleaned.length === 10) {
        let match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);   // Creates groupings of 3 & 4.
        phoneNumber = `${match[1]}-${match[2]}-${match[3]}`;
    } else {
        phoneNumber = number;
    }

    return phoneNumber;
};

function orEmpty(string) {
    return string ? `, ${string}` : '';
};

function formatAddress(address) {
    return `${address.address1}` +
        `${orEmpty(address.address2)}` +
        `${orEmpty(address.apartment)}` +
        `${orEmpty(address.city)}` +
        `${orEmpty(address.state)}` +
        `${orEmpty(address.zip)}`;
}

export {formatAddress, formatPhoneNumber};